import QRCode from "qrcode";
import { useState } from "react";
import PageContent from "../components/PageContent";
import feedbackDomain from "../domainFeedbackForm";

export default function FeedbackQRCode() {
  console.log("rednering feedback qr code");
  const [blob, setBlob] = useState();
  let id = localStorage.getItem("restaurantId");
  let role = localStorage.getItem("role");
  if(role != "hq"){
    let link = `${"https://wa.me/+15559627896?text=Foodie "}${id}`;
  
  QRCode.toDataURL(link)
    .then((url) => {
      setBlob(url);
      //   console.log(url);
    })
    .catch((err) => {
      console.log("erro while qrcode");
    });
  }
  else{ 

  }
  function printHandler() {
    let btn = document.getElementById("printBtn");

    // parent.style.visibility = "hidden";
    // btn.style.visibility = "hidden";

    // window.print();
    // var content = document.getElementById("divcontents");
    // var pri = document.getElementById("divcontents").contentWindow;
    // pri.document.open();
    // pri.document.write(content.innerHTML);
    // pri.document.close();
    // pri.focus();
    // pri.print();

    var prtContent = document.getElementById("divcontents");
    var WinPrint = window.open(
      "",
      "",
      "left=200,top=200,width=1500,height=2000,toolbar=0,scrollbars=0,status=0"
    );
    WinPrint.document.write(prtContent.innerHTML);
    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  }
  return (
    <>
      <PageContent>
        

        { role != "hq" ? <><div id="divcontents">
          <h1> Feedback</h1>
          <p>Kindly Spare a few minutes to give us your valuable feedback</p>
          <br></br>
          <img src={blob} alt="" />
        </div>

        <button id="printBtn" onClick={printHandler}>
          Print
        </button></> : <> <p>This Page is Unavailable to account with role HQ</p></>}
      </PageContent>
    </>
  );
}
